import { render, staticRenderFns } from "./ClicksTable.vue?vue&type=template&id=a34c9988&scoped=true&"
import script from "./ClicksTable.vue?vue&type=script&lang=js&"
export * from "./ClicksTable.vue?vue&type=script&lang=js&"
import style0 from "./ClicksTable.vue?vue&type=style&index=0&id=a34c9988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34c9988",
  null
  
)

export default component.exports